import React from 'react';
import './UIAlert.scss';

export interface UIAlertProps {
  /**
   * Варіант кольору алерту
   */
  variant?: 'primary' | 'secondary' | 'success' | 'danger' | 'warning';

  /**
   * Текст алерту
   */
  children: React.ReactNode;

  /**
   * Додатковий CSS клас
   */
  className?: string;

  /**
   * Показувати кнопку закриття
   */
  closable?: boolean;

  /**
   * Callback при закритті алерту
   */
  onClose?: () => void;

  /**
   * Повна ширина
   */
  fullWidth?: boolean;

  /**
   * Статичне позиціонування замість фіксованого
   */
  static?: boolean;
}

const baseClass = 'UIAlert';

const UIAlert: React.FC<UIAlertProps> = ({
                                           variant = 'primary',
                                           children = 'This is an alert message',
                                           className = '',
                                           closable = false,
                                           onClose,
                                           fullWidth = false,
                                           static: isStatic = false,
                                         }) => {
  const alertClasses = [
    baseClass,
    `${baseClass}--${variant}`,
    fullWidth && `${baseClass}--full-width`,
    !isStatic && `${baseClass}--fixed`,
    className
  ].filter(Boolean).join(' ');

  return (
    <div className={alertClasses}>
      <div className={`${baseClass}__content`}>
        {children}
      </div>

      {closable && (
        <button
          className={`${baseClass}__close`}
          onClick={onClose}
          aria-label="Close alert"
        >
          <svg width="10" height="10" viewBox="0 0 10 10" fill="none">
            <path
              d="M9 1L1 9M1 1L9 9"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>
      )}
    </div>
  );
};

export default UIAlert;